import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type IpExceptionResponse = { error?: ApiError };

export const EnableIpException = async (studentId: string): Promise<IpExceptionResponse> => {
  try {
    await axios.post(`/admin/students/${studentId}/ip-exception`);
    return {};
  } catch (error: any) {
    return { error: error.response?.data ?? { message: "Unexpected error" } };
  }
};

export const DisableIpException = async (studentId: string): Promise<IpExceptionResponse> => {
  try {
    await axios.delete(`/admin/students/${studentId}/ip-exception`);
    return {};
  } catch (error: any) {
    return { error: error.response?.data ?? { message: "Unexpected error" } };
  }
};
